export default __webpack_public_path__ + "images/bullet1-D4M0D.png";